import React, { useState } from "react";
import axios from "axios";
import { toast } from "react-hot-toast";
import {
  Box,
  Button,
  CircularProgress,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  IconButton,
  Typography,
} from "@mui/material";
import { Close } from "@mui/icons-material";
import { API_SERVICE_BACKEND } from "src/config";

const AddPaymentCard = ({ setOpen, open, isDfyPage }) => {
  const [isLoading, setIsLoading] = useState(false);

  const handleClose = () => {
    setOpen(false);
  };

  const handleNewPaymentMethod = async () => {
    try {
      setIsLoading(true);
      const response = await axios.post(
        `${API_SERVICE_BACKEND}/payment-method`,
        {
          userEmail: sessionStorage.getItem("userEmail"),
          isDfyPage,
        }
      );
      handleClose(false);
      if (response.data.url) {  
        window.open(response.data.url, "_blank");
      }
      if(response?.data?.error){
        toast.error(response.data.error);
      }
      //console.log("Payment method added successfully:", response.data);
    } catch (error) {
      //console.log("Error adding payment method:", error);
      const errorMessage = 
        error?.response?.data?.error || 
        error?.response?.data?.message || 
        error?.message || 
        "Failed to add payment method";
      toast.error(errorMessage);
      //console.log(error);
    } finally {
      setIsLoading(false);
    }
  };

  return (
    <Dialog open={open} onClose={handleClose} maxWidth="xs" fullWidth>
      <DialogTitle>Add a Payment Card</DialogTitle>
      <Box position="absolute" top={0} right={0}>
        <IconButton onClick={handleClose}>
          <Close />
        </IconButton>
      </Box>
      <DialogContent>
        <Typography variant="body1" gutterBottom>
          Please enter your payment card details to continue.
        </Typography>
      </DialogContent>
      <DialogActions>
        <Button onClick={handleClose} color="primary" variant="outlined" className="glass-button-secondary-50">
          Cancel
        </Button>
        <Button
          onClick={handleNewPaymentMethod}
          color="primary"
          variant="contained"
          disabled={isLoading}
        >
          {isLoading ? (
            <CircularProgress color="inherit" size={25} />
          ) : (
            "Add Card"
          )}
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default AddPaymentCard;
